import React from 'react';
import './HowItWorks.scss';
import { Image } from 'components/atoms';
import search from 'assets/images/icons/facilityPage/search.svg';
import reserve from 'assets/images/icons/facilityPage/reserve.svg';
import movein from 'assets/images/icons/facilityPage/movein.svg';
import one from 'assets/images/icons/facilityPage/one.svg';
import two from 'assets/images/icons/facilityPage/two.svg';
import { Section, Container } from 'components/core/Page';

export default function HowItWorks() {
	return (
		<Section className="how-it-works-hero">
			<Container className="hero-content">
				{/* Left Content */}
				<div className="hero-text">
					<h2 className="hero-title">
						How Renting a Self Storage Unit Works
					</h2>

					<p className="hero-subtitle">
						There are two time-saving ways to rent self storage
						space at this facility: 
					</p>

					<ol className="hero-list">
						<li>
							<Image
								src={one}
								alt="one icon"
								className="step-icon"
							/>
							Reserve your unit online today and head straight to
							your unit on move-in day.
						</li>
						<li>
							<Image
								src={two}
								alt="two icon"
								className="step-icon"
							/>
							Reserve for free with no payment required until you
							sign your lease on move-in day. Lock in your rate
							without even entering your credit card information. 
						</li>
					</ol>
				</div>

				{/* Right Card */}
				<div className="info-card">
					<span className="info-card-title">How It Works</span>

					<div className="card-item">
						<Image
							src={search}
							alt="search icon"
							className="img"
						/>
						<div>
							<strong className="text">
								Pick your self storage unit
							</strong>
						</div>
					</div>

					<div className="card-item">
						<Image
							src={reserve}
							alt="reserve icon"
							className="img"
						/>
						<div>
							<strong className="text">
								Reserve online with us for free
							</strong>
							<p>Cancel or update anytime, no strings attached</p>
						</div>
					</div>

					<div className="card-item">
						<Image
							src={movein}
							alt="move in icon"
							className="img"
						/>
						<div>
							<strong className="text">
								Visit your facility
							</strong>
							<p>Move in and get organised!</p>
						</div>
					</div>
				</div>
			</Container>
		</Section>
	);
}
